export class TextEditorController {
    static $inject = ['close', 'source', 'syntax'];
    constructor(close, source, syntax) {
        this.syntax = syntax;
        this.confirm = () => this.close(this.source);
        this.cancel = () => this.close();
        this.close = close;
        this.source = source;
    }
    set source(content) {
        this.error = false;
        this._source = content;
        if (this.syntax == SourceSyntax.JSON) {
            try {
                JSON.parse(content);
            }
            catch (e) {
                this.error = true;
            }
        }
    }
    get source() {
        return this._source;
    }
}
export var SourceSyntax;
(function (SourceSyntax) {
    SourceSyntax[SourceSyntax["Text"] = 0] = "Text";
    SourceSyntax[SourceSyntax["JSON"] = 1] = "JSON";
    SourceSyntax[SourceSyntax["Javascript"] = 2] = "Javascript";
})(SourceSyntax || (SourceSyntax = {}));
